var formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(
    oldNode,
    newContent,
    preProcessCallbacks = [],
    postProcessCallbacks = []
  ) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement("div");
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll("[id], [form]").forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form &&
        element.setAttribute(
          "form",
          `${element.form.getAttribute("id")}-${uniqueKey}`
        );
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = "none";

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("change", (event) => {
      const target = this.getInputForEventTarget(event.target);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  getInputForEventTarget(target) {
    return target;
  }

  slideTo(target) {
    console.log();
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll("fieldset input:checked")).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}
async function filterCartItemsBySku(response) {
  try {
    const cartResponse = await fetch("/cart.js");
    const { items } = await cartResponse.json();
    const filteredItems = items.filter(item => item.sku === response.sku);
    return filteredItems;
  } catch (error) {
    console.error("Error fetching cart:", error);
  }
}
async function handleCartToast(response, addQuantity) {
  const filterCartData = await filterCartItemsBySku(response);
  if (filterCartData && filterCartData.length) {
    Alpine.store('cartToast').showToast(
      response.product_title,
      addQuantity,
      filterCartData[0].image
    );
  }
}
customElements.define("variant-selects", VariantSelects);

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.toOpenCart = true;
        this.form = this.querySelector("form");

        if (this.form == null) {
          return;
        }

        if (
          this.variantIdInput &&
          this.variantIdInput.hasAttribute("disabled")
        ) {
          this.variantIdInput.disabled = false;
        }

        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-drawer");

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
      
        this.handleErrorMessage();
      
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("disabled");
      
        const config = {
          method: "POST",
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          credentials: "same-origin",
        };
      
        const formData = new FormData(this.form);
        const addQuantity = formData.get("quantity");
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
      
        config.body = formData;
      
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (this.hasAttribute("data-open-cart")) {
              this.toOpenCart = this.getAttribute("data-open-cart");
            }
      
            this.toOpenCart = false;
      
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
      
              this.handleErrorMessage(response.description);
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                openCart: this.toOpenCart,
                productVariantId: formData.get("id"),
                cartData: response,
              });
            handleCartToast(response, addQuantity);
            this.error = false;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("disabled");
      
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector("[data-product-form-error-wrapper]");

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            "[data-product-form-error-message]"
          );

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.errorMessageWrapper.classList.remove("hidden");
        }
      }

      get variantIdInput() {
        if (this.form) {
          return this.form.querySelector("[name=id]");
        }

        return null;
      }
    }
  );
}

class QuantitySelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeQuantitySelector();
  }

  initializeQuantitySelector() {
    const minusButton = this.querySelector('button[name="minus"]');
    const plusButton = this.querySelector('button[name="plus"]');
    const quantityInput = this.querySelector('input[type="number"]');
    const maxQuantity = parseInt(quantityInput.getAttribute("max"), 10); // Get the max value from the input attribute

    const triggerChangeEvent = () => {
      quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
    };

    minusButton.addEventListener("click", () => {
      let currentValue = parseInt(quantityInput.value, 10);
      if (currentValue > 1) {
        quantityInput.value = currentValue - 1;
        triggerChangeEvent();
      }
    });

    plusButton.addEventListener("click", () => {
      let currentValue = parseInt(quantityInput.value, 10);

      console.log(maxQuantity);

      if (!isNaN(maxQuantity) && currentValue < maxQuantity) {
        quantityInput.value = currentValue + 1;
        triggerChangeEvent();
      }
    });

    quantityInput.addEventListener("input", () => {
      let currentValue = parseInt(quantityInput.value, 10);

      if (currentValue < 1) {
        quantityInput.value = 1; // Enforce minimum value
      } else if (!isNaN(maxQuantity) && currentValue > maxQuantity) {
        quantityInput.value = maxQuantity; // Enforce maximum value
      }

      triggerChangeEvent();
    });
  }
}

customElements.define("quantity-selector", QuantitySelector);

if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);

  this.provinceEl = document.getElementById(province_domid);

  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.img = this.querySelector("img");
    this.productData = null;
    this.productForm = null;
  }

  connectedCallback() {
    this.loadProductData();
    this.setupEventListeners();
  }

  loadProductData() {
    const productDataElement = this.querySelector(".product-card_json");
    if (productDataElement) {
      this.productData = JSON.parse(productDataElement.textContent);
    }

    this.productForm = this.querySelector("product-form");
  }

  setupEventListeners() {
    if (!this.productData) return;

    this.querySelectorAll("input").forEach((radio) => {
      radio.addEventListener("change", () => this.handleOptionChange());
    });
  }

  handleOptionChange() {
    if (!this.productData) return;

    const selectedOptions = Array.from(
      this.querySelectorAll("input:checked")
    ).map((input) => ({
      name: input.dataset.optionName,
      value: input.value,
    }));

    const matchedVariant = this.productData.variants.find((variant) => {
      return selectedOptions.every((option) => {
        const optionIndex = this.productData.options.indexOf(option.name);
        return variant.options[optionIndex] === option.value;
      });
    });

    if (matchedVariant) {
      this.updateProductDetails(matchedVariant);
    }
  }

  updateProductDetails(variant) {
    if (variant == null) {
      return;
    }

    const price = formatMoney(variant.price, window.moneyFormat);

    const priceElement = this.querySelector(".price");
    const variantInput = this.querySelector('[name="id"]');

    if (variant.compare_at_price) {
      const compareAtPrice = formatMoney(
        variant.compare_at_price,
        window.moneyFormat
      );
      this.querySelector(".compare-at-price").textContent = compareAtPrice;
    }

    if (variant.featured_image) {
      const imageSrc = variant.featured_image.src;
      this.img.src = imageSrc;
    }

    if (variantInput) {
      this.productForm.querySelector('[name="id"]').value = variant.id;
    }

    if (priceElement) {
      this.querySelector(".price").textContent = price;
    }
  }
}

customElements.define("product-card", ProductCard);

class HeaderDropdown extends HTMLElement {
  constructor() {
    super();
    this.openDropdowns = []; // Track currently open dropdowns
  }

  connectedCallback() {
    const menuItems = this.querySelectorAll(".main-menu_item");
    const headerOverlay = document.querySelector(".header_overlay");
    const menuList = this.querySelector(".main-menu_link-list");

    const isTouchDevice =
      "ontouchstart" in window || navigator.maxTouchPoints > 0;

    let isMouseInsideMenu = false;
    let openTimeout;

    if (!isTouchDevice) {
      // Only for desktop: track when user leaves entire menu
      menuList.addEventListener("mouseleave", () => {
        isMouseInsideMenu = false;
      });
    }

    menuItems.forEach((menuItem) => {
      const dropdown = menuItem.querySelector(".main-menu_dropdown");
      const activeSpan = menuItem.querySelector(".main-menu_active-span");

      if (dropdown) {
        if (isTouchDevice) {
          // For touch devices: click to open directly
          menuItem.addEventListener("click", (e) => {
            e.stopPropagation();
            this.closeAllDropdowns();
            this.toggleDropdown(dropdown, activeSpan, headerOverlay);
            document.addEventListener(
              "click",
              this.handleOutsideClick.bind(
                this,
                dropdown,
                activeSpan,
                headerOverlay
              ),
              { once: true }
            );
          });
        } else {
          // For non-touch devices (desktop): hover with delay
          menuItem.addEventListener("mouseenter", () => {
            this.closeAllDropdowns();

            if (!isMouseInsideMenu) {
              openTimeout = setTimeout(() => {
                this.openDropdown(dropdown, activeSpan, headerOverlay);
                isMouseInsideMenu = true;
              }, 500); // Delay only first time
            } else {
              this.openDropdown(dropdown, activeSpan, headerOverlay);
            }
          });

          menuItem.addEventListener("mouseleave", () => {
            clearTimeout(openTimeout);
            this.closeDropdown(dropdown, activeSpan, headerOverlay);
          });

          // Allow click on desktop too if needed
          menuItem.addEventListener("click", (e) => {
            this.closeAllDropdowns();
            this.toggleDropdown(dropdown, activeSpan, headerOverlay);
          });
        }
      }
    });
  }

  openDropdown(dropdown, activeSpan, headerOverlay) {
    this.closeAllDropdowns();
    dropdown.classList.remove("hidden");
    activeSpan.classList.remove("hidden");
    if (headerOverlay) {
      headerOverlay.classList.remove("hidden");
    }

    this.openDropdowns.push({ dropdown, activeSpan, headerOverlay });
  }

  closeDropdown(dropdown, activeSpan, headerOverlay) {
    dropdown.classList.add("hidden");
    activeSpan.classList.add("hidden");
    if (headerOverlay) {
      headerOverlay.classList.add("hidden");
    }

    this.openDropdowns = this.openDropdowns.filter(
      (item) => item.dropdown !== dropdown
    );
  }

  toggleDropdown(dropdown, activeSpan, headerOverlay) {
    if (dropdown.classList.contains("hidden")) {
      this.openDropdown(dropdown, activeSpan, headerOverlay);
    } else {
      this.closeDropdown(dropdown, activeSpan, headerOverlay);
    }
  }

  handleOutsideClick(dropdown, activeSpan, headerOverlay, event) {
    if (!dropdown.contains(event.target)) {
      this.closeDropdown(dropdown, activeSpan, headerOverlay);
    }
  }

  closeAllDropdowns() {
    // Close all currently open dropdowns
    this.openDropdowns.forEach(({ dropdown, activeSpan, headerOverlay }) => {
      this.closeDropdown(dropdown, activeSpan, headerOverlay);
    });

    // Clear the open dropdowns list
    this.openDropdowns = [];
  }
}

// Register custom element
customElements.define("header-dropdown", HeaderDropdown);

// Notification bar swiper

let notSwiper = document.querySelector("[swiper='not']");

if (notSwiper) {
  const swiperElement = notSwiper.querySelector(".swiper");

  var swiper = new Swiper(swiperElement, {
    speed: 300,
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    centeredSlides: false,
    mousewheel: { forceToAxis: true },
    breakpoints: {
      480: { slidesPerView: 1, spaceBetween: 0, slidesPerGroup: 1 },
      768: {
        slidesPerView: 2,
        spaceBetween: 0,

        slidesPerGroup: 1,
      },
      992: {
        slidesPerView: "auto",
        spaceBetween: 0,
        slidesPerGroup: 1,
      },
    },
  });
}

// tool tips

document.addEventListener("DOMContentLoaded", () => {
  const tooltips = document.querySelectorAll("[data-tooltip]");

  tooltips.forEach((tooltip) => {
    const tooltipContent = tooltip.querySelector(".tooltip");

    if (tooltipContent) {
      const showTooltip = () => tooltipContent.classList.remove("hidden");
      const hideTooltip = () => tooltipContent.classList.add("hidden");

      tooltip.addEventListener("mouseenter", showTooltip);
      tooltip.addEventListener("mouseleave", hideTooltip);

      tooltip.addEventListener("touchstart", (e) => {
        e.preventDefault();
        if (tooltipContent.classList.contains("hidden")) {
          showTooltip();
        } else {
          hideTooltip();
        }
      });

      document.addEventListener("touchstart", (e) => {
        if (!tooltip.contains(e.target)) {
          hideTooltip();
        }
      });
    }
  });
});

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: "0px 0px 400px 0px" }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(
      `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`
    )
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .then(() => {
        initRecommandSwiper();
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define("product-recommendations", ProductRecommendations);

function initRecommandSwiper() {
  let recommandSwiper = document.querySelector("[swiper='recommand']");

  if (recommandSwiper) {
    const swiperElement = recommandSwiper.querySelector(".swiper");

    const prevButton = recommandSwiper.querySelector("[swiper='prev']");
    const nextButton = recommandSwiper.querySelector("[swiper='next']");

    prevButton.addEventListener("click", (e) => {
      console.log(e);
    });

    var swiper = new Swiper(swiperElement, {
      speed: 300,
      slidesPerView: "auto",
      spaceBetween: 20,
      loop: false,
      centeredSlides: false,
      mousewheel: { forceToAxis: true },
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
        disabledClass: "opacity-0",
      },
      breakpoints: {
        480: { slidesPerView: "auto", spaceBetween: 20, slidesPerGroup: 1 },
        768: { slidesPerView: "auto", spaceBetween: 20, slidesPerGroup: 1 },
        992: {
          slidesPerView: 4,
          spaceBetween: 20,
          slidesPerGroup: 1,
        },
      },
    });
  }
}
